import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { normalizeHttpError, SemanticPathService, SiteContextActions, withdrawOn } from '@spartacus/core'
import { PoUploadConnector } from '../../connectors/po-upload/po-upload.connector'
import { catchError, map, mergeMap } from 'rxjs/operators'
import { of } from 'rxjs'
import { PoUploadActions } from '../actions'
import { Router } from '@angular/router'

@Injectable({
  providedIn: 'root'
})
export class PoUploadEffects {

  private contextChange$ = this.actions$.pipe(
    ofType(
      SiteContextActions.CURRENCY_CHANGE,
      SiteContextActions.LANGUAGE_CHANGE
    )
  )

  poUpload$ = createEffect(() => this.actions$.pipe(
    ofType(PoUploadActions.PURCHASE_ORDER_UPLOAD),
    map((action: PoUploadActions.PurchaseOrderUpload) => action?.payload),
    mergeMap(payload => this.poUploadConnector.post(payload?.form).pipe(
      mergeMap(() => {
        this.router.navigate([this.semanticPathService.get('poUploadConfirmation')])
          .catch(error => console.error(error))
        return [
          new PoUploadActions.PurchaseOrderUploadSuccess({})
        ]
        }
      ),
      catchError(error => of(new PoUploadActions.PurchaseOrderUploadFail(normalizeHttpError(error))))
      )
    ),
    withdrawOn(this.contextChange$)
  ))

  constructor (protected actions$: Actions,
               protected poUploadConnector: PoUploadConnector,
               protected router: Router,
               protected semanticPathService: SemanticPathService) { }
}
